import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import Subscription from "./Subscription";
import Product from "./Product";

@Entity({one: "entry", many: "entries"})
export default class Entry {

	@Field()
	public id: ID;

	@Field()
	public displayName?: string;

	@Field({entity: Product})
	public product: Product;

	@Field({entity: Subscription})
	public subscription: Subscription;

}



// WEBPACK FOOTER //
// ./src/panels/programStatus/entities/Entry.ts